import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'hi', 'ar'],
    defaultNS: 'common',
    ns: [
      'common', 'sidebar', 'validation', 'tprm', 'policy', 'user_mgmt',
      'edit_third_party', 'questionnaire_create', 'ai_quiz', 'questionnaire_view', 'tprm_questionnaire',
      'documentation_generator', 'documentation_page', 'document_vault', 'policy_library',
      'vrm', 'department_management', 'audit_trail_user', 'my_users', 'role_management', 'tprm_tracker',
      'create_cara_user', 'tprm_dashboard', 'audit_trail_users',
      'upgrade', 'tprm_admin_dashboard', 'create_tprm_user', 'cara_tprm_user_details',
      'ask_the_expert', 'submit_feedback', 'my_feedback', 'privacy', 'audit_trails', 'command_center',
      'breadcrumb', 'risk_register', 'risk_register_tracker', 'risk_assessment_tracker',
      'risk_assessment', 'cara_roi_quantifier',
      'asset_management', 'process_management', 'asset_mapping', 'audit_checklist',
      'checklist_template', 'entity_dashboard', 'manage_audit', 'audit_tracker', 'header',
      'create_audit', 'add_audit_task', 'auditor_dashboard',
      'cis_risk_register', 'isms_risk_register', 'risk_dashboard', 'risk_register_import', 'report_builder',
      'audit_document',
      'login', 'session_guard', 'otp', 'tprm_login', 'tprm_user_login', 'cara_login', 'superadmin_login', 'vrm_login',
      'frameworks_and_standards', 'framework_common', 'compliance_tracker',
      'admin_vrm_recommendations', 'vrm_recommendations', 'vrm_tracker', 'vrm_advisory_card',
      'progress_tracker', 'evidence_tracker', 'question_bank', 'tprm_questionnaire_wizard',
      'tprm_assessment_workspace', 'tprm_v2_questionnaire', 'tprm_custom_questionnaire', 'superadmin_ai_usage', 'gap_intelligence', 'record_ownership',
    ],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'cookie', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'cara_lang',
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false, // avoid blank screen issues during loading
    }
  });

// Handle RTL direction dynamically
i18n.on('languageChanged', (lng) => {
  const dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dir = dir;
  document.documentElement.lang = lng;
});

export default i18n;
